import {
  Button,
  Stack,
  Typography,
  Paper,
  Box,
  styled,
  Badge,
} from "@mui/material";
import { CustomDndTable } from "../../../shared";
import { createColumnHelper } from "@tanstack/react-table";

const StyledBadge = styled(Badge)(({ background }) => ({
  "& .MuiBadge-badge": {
    right: 4,
    top: 10,
    padding: "0 4px",
    position: "relative",
    background,
  },
}));

export const SubCategoryProductsDialog = (props) => {
  const {
    handleModal,
    ColorButton,
    productsList,
    onSearchChange,
    onCategoryProductOrderChange,
    handleProductSortOrder,
    recipeListQuery,
    category,
  } = props;

  const columnHelper = createColumnHelper(productsList);

  const columns = [
    columnHelper.accessor("name", {
      header: () => "Product",
    }),
  ];

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      <CustomDndTable
        defaultData={productsList}
        columns={columns}
        headerText={
          <Stack direction="row" width="412px" alignItems="center" gap="6px">
            <Typography fontWeight={500} fontSize="16px">
              {category?.subcategoryName}
            </Typography>
            <StyledBadge
              badgeContent={productsList?.length}
              background="#0909091F"
            />
          </Stack>
        }
        subRow={"subRows"}
        isLoading={recipeListQuery?.isPending}
        allRowsExpanded={true}
        manualPagination={true}
        isPagination={false}
        isSearching={false}
        onSearchChange={onSearchChange}
        disableDrag={category?.searchKey}
        searchText={category?.searchKey}
        customRowStyle={(row) => {
          return !row.depth ? { borderBottom: "none" } : null;
        }}
        onRowOrderChange={(data) => onCategoryProductOrderChange(data)}
        tableContainerStyle={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      />
      <Stack
        component={Paper}
        elevation={3}
        direction="row"
        gap="8px"
        display="flex"
        justifyContent="end"
        padding="16px"
        sx={{
          boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.12)",
          bottom: 0,
          position: "absolute",
          width: "100%",
        }}
      >
        <ColorButton
          variant="outlined"
          color="gray2"
          onClick={() => handleModal(false)}
        >
          Close
        </ColorButton>
        <Button
          variant="contained"
          onClick={handleProductSortOrder}
          disabled={!category?.recipeListItems?.length}
          size="small"
          sx={{ width: "78px" }}
        >
          Save
        </Button>
      </Stack>
    </Box>
  );
};
